import React, {useEffect, useState} from "react";
import {
    Alert,
    Backdrop,
    Button,
    CircularProgress,
    Container,
    Grid,
    IconButton,
    InputBase,
    Paper,
    styled,
    Tooltip
} from "@mui/material";
import {useLocation} from "react-router-dom";
import Typography from "@mui/material/Typography";
import NuccSpecialtyValueSetPagePasteURLPanel from "./NuccSpecialtyValueSetPagePasteURLPanel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import {useDispatch, useSelector} from "react-redux";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import ShowSnackbar from "../utils/ShowSnackbar";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import {addLatestBatch, batchOnRefresh, getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: '200px'
}))
const StyledInnerPaper = styled(Paper)(({theme}) => ({
    paddingLeft: theme.spacing(1),
    backgroundColor: '#FFEFD5',
    maxHeight: '40px',
    lineHeight: '40px',
}))

export default function NuccSpecialtyValueSetNewImportTask(props) {
    const location = useLocation();
    const path = location.pathname;
    const dispatch = useDispatch();
    const {taxonomyBatchId, taxonomyStatus} = useSelector(state => state.taxonomyBatch);
    const { nuccBatches, batchRefresh } = useSelector(state => state.allBatches);

    const [nuccDataPath, setNuccDataPath] = useState({})
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''})


    useEffect(() => {
        // getActiveBatchProgress("Taxonomy", setLoading, setSnackbarMsg)
        //     .then(res => {
        //         dispatch(addTaxonomyBatch(res));
        //     })
        dispatch(getAllBatches());
    }, [batchRefresh])


    const handleStartImportTask = async (individual, nonIndividual) => {
        if (!individual || !nonIndividual) {
            return;
        }

        const urls = [individual, nonIndividual];
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(urls)
        }
        console.info(requestOptions);

        try {
            setLoading(true);
            const res = await fetch(ApiUrl.ExternalSource.importTaxonomyUrl, requestOptions)
            const data = await handleHttpResponse(res);
            dispatch(addLatestBatch({ type: 'nucc', 'id': data.id, 'batch': data}));
            dispatch(batchOnRefresh());
        } catch (err) {
            console.error("Import task failed, " + err);
            setSnackbarMsg({open: true, msg: "Failed to Import New Task", msgLv: 'error'})
        } finally {
            setLoading(false);
        }

        // fetch(ApiUrl.ExternalSource.importTaxonomyUrl, requestOptions)
        //     .then(handleHttpResponse)
        //     .catch((err) => {
        //         if (err) {
        //             console.error("Import task failed, " + err);
        //             setSnackbarMsg({open: true, msg: "Failed to Import New Task", msgLv: 'error'})
        //         }
        //     })
        //     .then(res => {
        //         if (res) {
        //             dispatch(addTaxonomyBatch(res));
        //         }
        //     })
    }

    const handleNonIndividualChange = (event) => {
        setNuccDataPath({...nuccDataPath, nonIndividual: event.target.value});
    }

    const handleIndividualChange = (event) => {
        setNuccDataPath({...nuccDataPath, individual: event.target.value});
    }


    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={path} />
            <h3 className="title">
                New Specialties Value Sets Import Task
            </h3>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Specialties Value Sets URL</h4>
                <StyledPaper sx={{minHeight: '120px'}}>
                    <Typography gutterBottom>
                        Please enter the URL:
                    </Typography>
                    <NuccSpecialtyValueSetPagePasteURLPanel setNuccDataPath={(s) => setNuccDataPath(s)}/>
                </StyledPaper>
            </Grid>
            <br/>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>CSV File URL</h4>
                <StyledPaper>
                    {/*{individual.length && nonIndividual.length && <div><Button variant='contained' onClick={handleStartImportTask} endIcon={<PlayCircleOutlineIcon />}> Start Import task</Button><br/><br/></div>}*/}
                    {nuccDataPath?.individual && nuccDataPath?.nonIndividual &&
                        <div>
                            <Button
                                variant='contained'
                                onClick={() => handleStartImportTask(nuccDataPath.individual, nuccDataPath.nonIndividual)}
                                endIcon={<PlayCircleOutlineIcon />}
                            >
                                Start Import task
                            </Button>
                            <br/>
                            <br/>
                        </div>
                    }
                    <Typography gutterBottom>Individual:</Typography>
                    <div>
                        <StyledInnerPaper variant="outlined">
                                {(nuccDataPath.individual && nuccDataPath.individual.length > 0) ?
                                    <div style={{ display: 'flex'}}>
                                        <Tooltip title={nuccDataPath.individual}>
                                            <InputBase
                                                value={nuccDataPath.individual}
                                                name='individual'
                                                autoComplete='off'
                                                onChange={handleIndividualChange}
                                                fullWidth
                                            />
                                        </Tooltip>
                                        <CopyToClipboard text={nuccDataPath.individual} style={{float: 'right'}}>
                                            <IconButton>
                                                <ContentCopyIcon/>
                                            </IconButton>
                                        </CopyToClipboard>

                                    </div> :
                                    <span style={{color: 'grey', fontFamily: 'Courier'}}>Individual CSV URL</span>
                                }
                        </StyledInnerPaper>
                    </div>
                    <br/>
                    <Typography gutterBottom>Non-Individual:</Typography>
                    <div>
                        <StyledInnerPaper variant="outlined" component='form'>
                            {(nuccDataPath.nonIndividual && nuccDataPath.nonIndividual.length > 0) ?
                                <div style={{display: 'flex'}}>
                                    <Tooltip title={nuccDataPath.nonIndividual}>
                                        <InputBase
                                            value={nuccDataPath.nonIndividual}
                                            name='nonIndividual'
                                            autoComplete='off'
                                            onChange={handleNonIndividualChange}
                                            fullWidth
                                        />
                                    </Tooltip>
                                    <CopyToClipboard text={nuccDataPath.nonIndividual} style={{float: 'right'}}>
                                        <IconButton>
                                            <ContentCopyIcon/>
                                        </IconButton>
                                    </CopyToClipboard>
                                </div>
                                : <span style={{color: 'grey', fontFamily: 'Courier'}}>Non individual CSV URL</span>
                            }
                        </StyledInnerPaper>
                    </div>
                </StyledPaper>
            </Grid>
            <br/>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Specialties Value Sets Import Progress</h4>
                <StyledPaper>
                    {/*{ taxonomyStatus && <Alert severity={batchCurrentStatus[taxonomyStatus].getStatus} icon={false}>{batchCurrentStatus[taxonomyStatus].getMsg("NUCC Specialty Value Set")}</Alert>}*/}
                    { nuccBatches.length > 0 && nuccBatches[0].status !== 'Init' &&
                        <Alert severity={batchCurrentStatus[nuccBatches[0].status].getStatus} icon={false}>{batchCurrentStatus[nuccBatches[0].status].getMsg("NUCC Specialty Value Set")}</Alert>}
                    <br/>
                    {/*{ taxonomyBatchId && taxonomyStatus !== 'Completed' && taxonomyStatus !== 'Cancelled' && taxonomyStatus !== 'Failed' &&*/}
                    {/*    <NuccSpecialtyValueSetBatchProcessBar /> }*/}
                    { nuccBatches.length > 0 && nuccBatches[0].status !== 'Completed' && nuccBatches[0].status !== 'Cancelled' && nuccBatches[0].status !== 'Failed' &&
                        // <NuccSpecialtyValueSetBatchProcessBar batch={nuccBatches[0]}/> }
                    <ExternalSourceBatchProgressBar batch={nuccBatches[0]}/> }
                </StyledPaper>
            </Grid>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading }>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}